// extracted by mini-css-extract-plugin
export default {"body":"modal_body__SQUnU"};